import { CompanyDto } from './company-dto.model';


export class ShiftDto implements IShiftDto {
    id!: number;
    company!: CompanyDto;
    shiftName!: string | undefined;
    inTime!: Date;
    outTime!: Date;
    fullDayHrs!: number;
    halfDayHrs!: number;
    isActive!: boolean;
    monthlyReliefMinutes!: number;
    shortLeaveMaxMinutes!: number;
    shortLeaveMinMinutes!: number;
    allowLateTime!: Date;
    allowEarlyTime!: Date;
    lunchStartTime!: Date;
    lunchEndTime!: Date;
    calcLateIn!: boolean;
    calcEarlyOut!: boolean;
    allowPaidLeave!: boolean;
    otCalcHours!: number;
    otMultiplier!: number;

    constructor(data?: IShiftDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.company = _data["company"] ? CompanyDto.fromJS(_data["company"]) : <any>undefined;
            this.shiftName = _data["shiftName"];
            this.inTime = _data["inTime"] ? new Date(_data["inTime"].toString()) : <any>undefined;
            this.outTime = _data["outTime"] ? new Date(_data["outTime"].toString()) : <any>undefined;
            this.fullDayHrs = _data["fullDayHrs"];
            this.halfDayHrs = _data["halfDayHrs"];
            this.isActive = _data["isActive"];
            this.monthlyReliefMinutes = _data["monthlyReliefMinutes"];
            this.shortLeaveMaxMinutes = _data["shortLeaveMaxMinutes"];
            this.shortLeaveMinMinutes = _data["shortLeaveMinMinutes"];
            this.allowLateTime = _data["allowLateTime"] ? new Date(_data["allowLateTime"].toString()) : <any>undefined;
            this.allowEarlyTime = _data["allowEarlyTime"] ? new Date(_data["allowEarlyTime"].toString()) : <any>undefined;
            this.lunchStartTime = _data["lunchStartTime"] ? new Date(_data["lunchStartTime"].toString()) : <any>undefined;
            this.lunchEndTime = _data["lunchEndTime"] ? new Date(_data["lunchEndTime"].toString()) : <any>undefined;
            this.calcLateIn = _data["calcLateIn"];
            this.calcEarlyOut = _data["calcEarlyOut"];
            this.allowPaidLeave = _data["allowPaidLeave"];
            this.otCalcHours = _data["otCalcHours"];
            this.otMultiplier = _data["otMultiplier"];
        }
    }

    static fromJS(data: any): ShiftDto {
        data = typeof data === 'object' ? data : {};
        let result = new ShiftDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["company"] = this.company ? this.company.toJSON() : <any>undefined;
        data["shiftName"] = this.shiftName;
        data["inTime"] = this.inTime ? this.inTime.toISOString() : <any>undefined;
        data["outTime"] = this.outTime ? this.outTime.toISOString() : <any>undefined;
        data["fullDayHrs"] = this.fullDayHrs;
        data["halfDayHrs"] = this.halfDayHrs;
        data["isActive"] = this.isActive;
        data["monthlyReliefMinutes"] = this.monthlyReliefMinutes;
        data["shortLeaveMaxMinutes"] = this.shortLeaveMaxMinutes;
        data["shortLeaveMinMinutes"] = this.shortLeaveMinMinutes;
        data["allowLateTime"] = this.allowLateTime ? this.allowLateTime.toISOString() : <any>undefined;
        data["allowEarlyTime"] = this.allowEarlyTime ? this.allowEarlyTime.toISOString() : <any>undefined;
        data["lunchStartTime"] = this.lunchStartTime ? this.lunchStartTime.toISOString() : <any>undefined;
        data["lunchEndTime"] = this.lunchEndTime ? this.lunchEndTime.toISOString() : <any>undefined;
        data["calcLateIn"] = this.calcLateIn;
        data["calcEarlyOut"] = this.calcEarlyOut;
        data["allowPaidLeave"] = this.allowPaidLeave;
        data["otCalcHours"] = this.otCalcHours;
        data["otMultiplier"] = this.otMultiplier;
        return data; 
    }
}

export interface IShiftDto {
    id: number;
    company: CompanyDto;
    shiftName: string | undefined;
    inTime: Date;
    outTime: Date;
    fullDayHrs: number;
    halfDayHrs: number;
    isActive: boolean;
    monthlyReliefMinutes: number;
    shortLeaveMaxMinutes: number;
    shortLeaveMinMinutes: number;
    allowLateTime: Date;
    allowEarlyTime: Date;
    lunchStartTime: Date;
    lunchEndTime: Date;
    calcLateIn: boolean;
    calcEarlyOut: boolean;
    allowPaidLeave: boolean;
    otCalcHours: number;
    otMultiplier: number;
}

